import * as types from "./mutation_types";

export default {
  [types.GENERAL_RESET_FORM_FACTURE](state) {
    const form = {
      nums: [],
    };
    Object.assign(state.pageFacture, { form });
  },

  [types.GENERAL_RESET_FORM_BORDEREAU](state) {
    const form = {};
    Object.assign(state.pageBordereau, { form });
  },

  [types.GENERAL_RESET_FORM_MARCHE](state) {
    const form = {};
    Object.assign(state.pageMarche, { form });
  },

  [types.GENERAL_RESET_FORM_CONTRAT](state) {
    const form = {};
    Object.assign(state.pageContrat, { form });
  },

  [types.GENERAL_RESET_FORM_TIER](state) {
    const form = {};
    Object.assign(state.pageTier, { form });
  },

  [types.GENERAL_RESET_FORM_COMMANDE](state) {
    const form = {
      nums: [],
    };
    Object.assign(state.pageCommande, { form });
  },

  [types.GENERAL_RESET_FORM_OD](state) {
    const form = {};
    Object.assign(state.pageOd, { form });
  },

  [types.GENERAL_RESET_FORM_MISSION](state) {
    const form = {};
    Object.assign(state.pageMission, { form });
  },

  [types.GENERAL_RESET_FORM_AUTREDOCUMENTCOMPTABLE](state) {
    const form = {};
    Object.assign(state.pageAutreDocumentComptable, { form });
  },
};
